import { render } from "./DnsZoneActions.vue?vue&type=template&id=bc88fca6&scoped=true&lang=pug"
import script from "./DnsZoneActions.vue?vue&type=script&setup=true&lang=js"
export * from "./DnsZoneActions.vue?vue&type=script&setup=true&lang=js"

import "./DnsZoneActions.vue?vue&type=style&index=0&id=bc88fca6&scoped=true&lang=sass"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc88fca6"]])

export default __exports__